import { create } from "zustand";

interface GalleryStoreState {
	images: File[];
}

interface GalleryStoreActions {
	findImage: (index: number) => File;
	setImages: (images: File[]) => void;
	addImages: (image: File) => void;
	updateImages: (index: number, image: File) => void;
	removeImages: (index: number) => void;
	reset: () => void;
}

type GalleryStore = GalleryStoreState & GalleryStoreActions;

const initialState: GalleryStoreState = {
	images: [],
};

export const useGalleryStore = create<GalleryStore>((set, get) => ({
	...initialState,
	findImage: (index) => {
		const { images } = get();
		return images[index];
	},
	setImages: (images) => set({ images }),
	addImages: (image) => set((state) => ({ images: [...state.images, image] })),
	updateImages: (index, image) =>
		set(() => {
			const { images } = get();
			const updatedImages = images.map((img, i) => (i === index ? image : img));
			return { images: updatedImages };
		}),
	removeImages: (index) =>
		set(() => {
			const { images } = get();
			const newImages = images.filter((_, i) => i !== index);
			return { images: newImages };
		}),
	reset: () => set(initialState),
}));
